module.exports = __webpack_public_path__ + "static/icon-world-f135f0a2dde0dbbee9cd81dd11092afd.svg";